import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeClockCircle1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "time-clock-circle-1" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 10.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 10.5,
			x2: 12,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 13.061,
			y1: 13.061,
			x2: 15.75,
			y2: 15.75
		})
	]
});
export default SvgTimeClockCircle1;
